var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndependenceAdaptability(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.58,126.68l-9.81-20L160,121.62m15.88-13.69A67.15,67.15,0,0,1,44,125.71M31.63,87.1l9.8,20L58.21,92.17M42.33,105.85A67.15,67.15,0,0,1,174.24,88.07m-52.63,43.42v25.17h-9.27V131.49h-7.81v25.17H95.25l-.13-25.17H87l8-26.86L80.17,63l8.35-3,8.27,22.58h23l8.5-23.48,8.75,2.85-15,42.51Zm-5.25-64.34A8.13,8.13,0,1,1,108.23,59,8.12,8.12,0,0,1,116.36,67.15Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndependenceAdaptability);
export default __webpack_public_path__ + "static/media/INDEPENDENCE_ADAPTABILITY.ac515e2f290eb9f69ef640745237a973.svg";
export { ForwardRef as ReactComponent };